import React from 'react'
import Paper from 'material-ui/Paper'
import Grid from 'material-ui/Grid'
import Table from 'material-ui/Table'
import { TableBody } from 'material-ui/Table'
import { TableCell } from 'material-ui/Table'
import { TableHead } from 'material-ui/Table'
import { TableRow } from 'material-ui/Table'
import Typography from 'material-ui/Typography'
import Card, { CardContent } from 'material-ui/Card'
import Button from 'material-ui/Button'
import Icon from 'material-ui/Icon'
import { withStyles } from 'material-ui/styles'
import styles from './styles'
import { getFormattedNumber } from '../../../../../../common/utils'

class RFSubtest extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      direction: 'row',
      justify: 'center',
      alignItems: 'center'
    }
  }

  render () {
    const {
      classes,
      translate,
      results,
      chartMeasurementUnit,
      subtestResultsDisplay,
      subtestResultsRemote,
      subtest,
      subtestRes
    } = this.props
    let testresult, data, margin
    const { alignItems, direction, justify } = this.state
    if (subtest === 'HeadRoom') {
      testresult = subtestRes
      data = testresult ? testresult.worst : null
      margin = testresult ? testresult.worst : null
    } else {
      testresult = results.data.subtests.find(x => x.subtesttype === subtest)
      data = testresult ? testresult.margin : null
      margin = testresult ? testresult.margin : null
    }

    if (data) {
      return (
        <Grid
          container
          spacing={0}
          justify='center'
          direction='row'
          alignItems='center'
          className={classes.RFsubtestContainer}
        >
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            alignContent='center'
          >
            <Grid item alignContent='center'>
              {testresult &&
                testresult.margin &&
                testresult.margin.handsettype &&
                <Typography className={classes.button}>
                  {testresult.margin.handsettype.toLowerCase() === 'display'
                    ? translate('results_chart_display')
                    : translate('results_chart_remote')}
                </Typography>}
            </Grid>
            <Grid
              container
              spacing={16}
              className={classes.demo}
              alignItems={alignItems}
              direction={direction}
              justify={justify}
            >
              <Grid
                item
                xs={6}
                sm={6}
                md={6}
                lg={6}
                xl={6}
                alignItems='flex-end'
              >
                <Typography className={classes.button}>
                  {translate('rfsubtest_margin')}
                </Typography>
                <Typography className={classes.title}>
                  {margin.margin === undefined || margin.margin === null ? '-' : getFormattedNumber(margin.margin) + translate("dB")}
                </Typography>
              </Grid>
              <Grid
                item
                xs={6}
                sm={6}
                md={6}
                lg={6}
                xl={6}
                alignItems='flex-start'
              >
                <Typography className={classes.button}>
                  {translate('rfsubtest_value')}
                </Typography>
                <Typography className={classes.title}>
                  {margin.value === undefined || margin.value === null ? '-' : getFormattedNumber(margin.value) + translate("dB")}
                </Typography>

              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )
    } else {
      return (
        <Grid container spacing={0}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

            <Grid
              container
              spacing={16}
              className={classes.demo}
              alignItems={alignItems}
              direction={direction}
              justify={justify}
            >
              <Grid item />

            </Grid>
          </Grid>
        </Grid>
      )
    }
  }
}

export default withStyles(styles)(RFSubtest)
